import api from './api';

export interface ConversationalRequest {
  message: string;
  context?: {
    previousMessages?: Array<{role: string, content: string}>;
    currentUser?: string;
  };
  modelName?: 'ollama' | 'openai' | 'claude';
}

export interface ConversationalResponse {
  success: boolean;
  data: {
    response: {
      type: 'action_result' | 'clarification' | 'confirmation';
      message: string;
      data?: any;
      intent?: {
        action: string;
        entity: string;
        confidence: number;
        extractedFields?: Record<string, any>;
      };
      suggestions?: string[];
    };
  };
}

class ConversationalCRMService {
  async processMessage(request: ConversationalRequest): Promise<ConversationalResponse> {
    try {
      const response = await api.post('/ai/crm/conversational', request);
      return response.data;
    } catch (error) {
      console.error('Error processing conversational message:', error);
      throw error;
    }
  }

  async getSuggestions(): Promise<string[]> {
    return [
      "Add contact John Smith, email john@example.com, title Sales Manager",
      "Update contact John Smith, phone 555-1234",
      "Search contact John",
      "Delete contact John Smith",
      "Add interaction with John Smith, meeting about project proposal"
    ];
  }
}

export const conversationalCRMService = new ConversationalCRMService();
